export const siteConfig = {
  name: "Tunis/events",
  url: process.env.BASE_UI_URL,
  ogImage: "https://tunis.events/og.jpg",
  description: "Découvrez les événements tendance à Tunis, et soyez averti quand de nouveaux sont créés.",
  links: {
    facebook: "https://www.facebook.com/BipEventsTunisie/",
    instagram: "https://www.instagram.com/bip.events/",
  },
};
